var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-layout" },
    [
      _c("alert"),
      _vm._v(" "),
      _vm.isMobile
        ? _c(
            "div",
            { staticClass: "ui vertical sidebar overlay left menu" },
            [
              _c("merchant-profile"),
              _vm._v(" "),
              _c("sidebar", { attrs: { tabs: _vm.tabs } }),
              _vm._v(" "),
              _c("sidebar-profile")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pusher" },
        [
          _c("global-announcement"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ui top massive icon menu zw-orange top-menu" },
            [
              !_vm.isMobile
                ? _c(
                    "router-link",
                    {
                      staticClass: "item logo",
                      attrs: { to: { name: "dashboard" } }
                    },
                    [_c("img", { attrs: { src: _vm.logo, alt: "Zietwing" } })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isMobile
                ? _c(
                    "a",
                    {
                      staticClass: "item",
                      attrs: { id: "sidebarreveal" },
                      on: {
                        click: function($event) {
                          _vm.showSidebar = !_vm.showSidebar
                        }
                      }
                    },
                    [_c("i", { staticClass: "sidebar icon" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("language-selector"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right menu" },
                [
                  _c("notification-bell"),
                  _vm._v(" "),
                  _vm.activeMerchant ? _c("merchant-menu") : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "zw fullheight" },
            [
              !_vm.isMobile
                ? _c("div", { staticClass: "zw lc" }, [
                    _c(
                      "div",
                      { staticClass: "ui vertical sticky zw menu top" },
                      [
                        _c("merchant-profile"),
                        _vm._v(" "),
                        _c("sidebar", { attrs: { tabs: _vm.tabs } }),
                        _vm._v(" "),
                        _c("sidebar-profile")
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "zw rc" }, [
                _c(
                  "div",
                  { staticClass: "content" },
                  [
                    _vm.activeMerchant === null
                      ? _c("semantic-loading", {
                          attrs: {
                            active: _vm.activeMerchant === null,
                            text: _vm.$t("globals.loaders.loading")
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.activeMerchant ? _c("child") : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "zw bottom right" }, [
                  _vm._v(
                    "\n\t\t\t\t\t\t© Zietwing " +
                      _vm._s(new Date().getFullYear()) +
                      "\n\t\t\t\t\t\t"
                  ),
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.showTerms = !_vm.showTerms
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("modals.termsandconds.normal_header"))
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("subscription-modal-container"),
              _vm._v(" "),
              _c(
                "semantic-modal",
                {
                  attrs: {
                    settings: {
                      content_classes: { content: true },
                      closeable: true,
                      closeable_button: true
                    }
                  },
                  model: {
                    value: _vm.showTerms,
                    callback: function($$v) {
                      _vm.showTerms = $$v
                    },
                    expression: "showTerms"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "ui header",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.$t("modals.termsandconds.normal_header")) +
                          "\n\t\t\t\t\t"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("user-terms"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "actions",
                      attrs: { slot: "actions" },
                      slot: "actions"
                    },
                    [
                      _c("div", { staticClass: "ui red deny button" }, [
                        _vm._v(_vm._s(_vm.$t("globals.buttons.close")))
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e8a08d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e8a08d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/app.vue
// module id = FYtd
// module chunks = 1